module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/components/ImageCodeModal/asset/reload.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/components/ImageCodeModal/asset/reload.png
// module id = 1305
// module chunks = 438